import { render, staticRenderFns } from "./handlingDialog.vue?vue&type=template&id=f8a67626&scoped=true"
import script from "./handlingDialog.vue?vue&type=script&lang=js"
export * from "./handlingDialog.vue?vue&type=script&lang=js"
import style0 from "./handlingDialog.vue?vue&type=style&index=0&id=f8a67626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a67626",
  null
  
)

export default component.exports